import { Injectable } from '@angular/core'
import { TableDefinition } from '@plantandfood/kup.core'

@Injectable()
export class CanesTableFactory {
    canes(): TableDefinition {
        return {
            sortActive: 'name',
            sortDirection: 'asc',
            tableId: 'canes',
            columns: [
                {
                    columnDef: 'name',
                    sortKey: 'name',
                    header: 'Name',
                    formatter: 'truncate',
                    show: true,
                    excluded: true,
                    tooltipKey: 'name',
                },
                {
                    columnDef: 'genotypeName',
                    sortKey: 'scion.genotype.name',
                    header: 'Genotype',
                    formatter: 'truncate',
                    tooltipKey: 'genotypeName',
                    show: true,
                },
                {
                    columnDef: 'genotypeSex',
                    sortKey: 'scion.genotype.sex',
                    header: 'Sex',
                    formatter: 'truncate',
                    show: true,
                    tooltipKey: 'genotypeSex',
                },
                {
                    columnDef: 'collectionName',
                    sortKey: 'collection.name',
                    header: 'Collection',
                    formatter: 'truncate',
                    tooltipKey: 'collectionName',
                    show: true,
                },
                {
                    columnDef: 'locationName',
                    sortKey: 'scion.plant.location.name',
                    header: 'Location',
                    formatter: 'truncate',
                    show: true,
                    tooltipKey: 'locationName',
                },
                {
                    columnDef: 'locationAddress',
                    sortKey: 'scion.plant.location.address',
                    header: 'Location Address',
                    formatter: 'truncate',
                    show: true,
                    tooltipKey: 'locationAddress',
                },
                {
                    columnDef: 'activeStatus',
                    sortKey: 'activeRange',
                    header: 'Status',
                    formatter: 'truncate',
                    show: true,
                    tooltipKey: 'activeStatus',
                    sortDisabled: true,
                },
            ],
        }
    }
}
